import { useQuery } from '@apollo/client';
import { GET_PROCESS_AREA_OR_PROCESS_WORKAROUNDS } from '../process-areas-and-processes-workarounds/queries';
import {
  ProcessAreaOrProcessWorkaroundResponse,
  WorkaroundType,
} from '../process-areas-and-processes-workarounds/types';

/**
 * Hook to get process area or process applications by process area UUID or process UUID and location UUID
 * @param processAreaId - The process area UUID
 * @param locationId - The location UUID
 * @returns An object containing the applications, loading, and error
 */
export const useProcessAreaOrProcessWorkarounds = (
  processAreaId?: string,
  processId?: string,
  locationId?: string,
) => {
  const variables = {
    data: {
      locationUUID: locationId,
      ...(!processId
        ? {
            uuid: processAreaId,
            type: WorkaroundType.PROCESS_AREA,
          }
        : { uuid: processId, type: WorkaroundType.PROCESS }),
    },
  };

  const { data, loading, error, refetch } =
    useQuery<ProcessAreaOrProcessWorkaroundResponse>(
      GET_PROCESS_AREA_OR_PROCESS_WORKAROUNDS,
      {
        variables,
      },
    );

  return {
    data: data?.getProcessAreaOrProcessWorkaround,
    loading,
    error,
    refetch,
  };
};
